import { Loader2 } from "lucide-react";

export function Loader() {
	return (
		<div className="flex items-center justify-center h-full">
			<Loader2 className="size-8 animate-spin text-primary" />
		</div>
	);
}
